import './style.scss';

export function who_is_hanan_faisal_block() {
  const block = document.querySelector('.who_is_hanan_faisal_block');
  if (!block) return;

}
